import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'or-email-address',
    template: `@if (emailaddress != null && emailaddress != '') {<a [href]="'mailto:' + emailaddress" class="or-primary-link text-lowercase"><i class="fas fa-envelope or-secondary"></i> {{ displayname || emailaddress }}</a>}`,
    styleUrls: ['./email-address.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmailAddressComponent implements OnInit {

  @Input() emailaddress = '';
  @Input() displayname: string;

  constructor() { }

  ngOnInit() {
  }
}
